import "css!js/file_viewer/ui/show_tools_button.module.out.css";
export const showTools = "_showTools_10bo0_5";
export const hidden = "_hidden_10bo0_14";
const classes = { "showTools": "_showTools_10bo0_5", "hidden": "_hidden_10bo0_14" };
export default classes;
//# sourceMappingURL=show_tools_button.module.css.preenvesnextjs.map
